"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
var Mask = /** @class */ (function () {
    function Mask() {
        this.symbols = '';
    }
    return Mask;
}());
exports.Mask = Mask;
//# sourceMappingURL=mask.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dateinputs@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_r_2yelhkp6sdgaltctm3m4k3bqy4/~/@progress/kendo-react-dateinputs/dist/npm/dateinput/models/mask.js
// module id = 317
// module chunks = 0